<template>
    <div :style="{ height, width, margin }">
        <ImageModal
            v-if="item.imageBig"
            :image-small="actualPath"
            :width="width"
            :height="height"
            :image-big="getImgPath(item.imageBig)"
            :caption="item.name"
            :align="align"
        />
        <img v-else :src="actualPath" :style="{ width, height, objectFit: 'contain' }" />
    </div>
</template>
<script>
import Globals from "@/components/globals";
import ImageModal from "@/components/ui/ImageModal";

export default {
    components: { ImageModal },
    props: {
        item: {
            type: Object,
            required: true
        },
        alt: {
            type: String,
            required: false
        },
        width: {
            type: String,
            required: false,
            default: "60px"
        },
        height: {
            type: String,
            required: false,
            default: "60px"
        },
        align: {
            type: String,
            required: false,
            default: "left"
        }
    },
    data() {
        return {
            modalActive: false,
            margin: this.align === "center" ? "auto" : "inherit"
        };
    },
    computed: {
        actualPath() {
            return this.item.image ? this.getImgPath(this.item.image) : "../../../../static/img/no_image.jpg";
        }
    },
    methods: {
        getImgPath(imgPath) {
            return Globals.getBaseUrl() + imgPath;
        }
    }
};
</script>
<style scoped lang="scss">
img {
    /**
      Undoing the rule "td img { position:absolute; }" which is in the base style sheet for whatever reason
     */
    position: relative !important;
    object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// ItemImage.vue?30305814